<template>
  <div class="page-container">
    <el-card class="page-content" shadow="never">
      <Tab type="task" />

      <div class="page-actions">
        <div class="select">
          <div class="item">
            <div class="ipt">
              <el-input v-model.trim="filters.taskId" placeholder="任务ID" clearable size="mini"
                @keyup.enter.native="handleSearch" />
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-input v-model.trim="filters.taskName" placeholder="任务名称" clearable size="mini"
                @keyup.enter.native="handleSearch" />
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-select v-model="filters.taskBelong" placeholder="任务所属" size="mini" style="width: 140px">
                <el-option v-for="item in taskBelongOptions" :key="item.label" :label="item.label"
                  :value="item.value" />
              </el-select>
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-select v-model="filters.taskType" placeholder="任务类型" size="mini" style="width: 120px">
                <el-option v-for="item in taskTypeOptions" :key="item.label" :label="item.label" :value="item.value" />
              </el-select>
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-select v-model="filters.taskStatus" placeholder="任务状态" size="mini" style="width: 120px">
                <el-option v-for="item in taskStatusOptions" :key="item.label" :label="item.label"
                  :value="item.value" />
              </el-select>
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-date-picker v-model="filters.createdRange" type="datetimerange" size="mini" range-separator="-"
                start-placeholder="创建开始" end-placeholder="创建结束" value-format="timestamp" style="width: 340px" />
            </div>
          </div>
          <div class="item">
            <el-button size="mini" type="primary" @click="openAdd">新建</el-button>
          </div>
          <div class="item">
            <el-button size="mini" type="primary" @click="handleSearch">查询</el-button>
          </div>
          <div class="item">
            <el-button size="mini" @click="handleReset">重置</el-button>
          </div>
        </div>
      </div>

      <el-table :data="tableList" height="calc(100vh - 340px)" size="mini" v-loading="loading">
        <el-table-column label="任务ID" width="90"><template slot-scope="scope">{{ scope.row.taskId || scope.row.id }}</template></el-table-column>
        <el-table-column prop="taskName" label="任务名称" min-width="140" show-overflow-tooltip />
        <el-table-column prop="taskBelongDesc" label="任务所属" min-width="100" />
        <el-table-column prop="taskLevelDesc" label="新人任务类别" min-width="110">
          <template slot-scope="scope">{{ scope.row.taskLevelDesc || taskLevelText(scope.row.taskLevel) }}</template>
        </el-table-column>
        <el-table-column prop="taskTypeDesc" label="任务类型" min-width="90" />
        <el-table-column prop="completeRuleTypeDesc" label="任务完成规则" min-width="110" />
        <el-table-column prop="conditionAmount" label="完成金额" min-width="90">
          <template slot-scope="scope">
            {{
              scope.row.conditionAmount == null || scope.row.conditionAmount === ''
                ? '--'
                : scope.row.conditionAmount
            }}
          </template>
        </el-table-column>
        <el-table-column label="任务发放时间段" min-width="200">
          <template slot-scope="scope">
            <div>{{ scope.row.grantStartTime | moment }}</div>
            <div>{{ scope.row.grantEndTime | moment }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="taskStatusDesc" label="任务状态" min-width="100">
          <template slot-scope="scope">
            <el-tag size="mini" :type="statusTag(scope.row).type">
              {{ scope.row.taskStatusDesc || statusTag(scope.row).text }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createdTime" label="任务创建时间" min-width="160">
          <template slot-scope="scope">
            {{ scope.row.createdTime | moment }}
          </template>
        </el-table-column>
        <el-table-column prop="updatedTime" label="任务更新时间" min-width="160">
          <template slot-scope="scope">
            {{ scope.row.updatedTime | moment }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="openView(scope.row)">
              详情
            </el-button>
            <el-button type="text" size="mini" @click="openEdit(scope.row)">
              编辑
            </el-button>
            <el-button type="text" size="mini" @click="openCopy(scope.row)">
              复制
            </el-button>
            <el-button v-if="scope.row.taskStatus === 'OFFLINE'" type="text" size="mini"
              @click="handleOnline(scope.row)">
              上线
            </el-button>
            <el-button v-if="scope.row.taskStatus && scope.row.taskStatus !== 'OFFLINE'" type="text" size="mini"
              @click="handleOffline(scope.row)">
              下线
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pag">
        <pagination :size="pagination.size" :total="totalCount" :page="pagination.page" @pageChanged="pageChanged" />
      </div>

      <TaskFormDialog v-model="formVisible" :mode="formMode" :task-id="currentId" :task-status="currentStatus"
        @success="fetchList" />
    </el-card>
  </div>
</template>

<script>
import Pagination from 'components/pagination'
import Tab from '../components/Tab'
import TaskFormDialog from './components/TaskFormDialog.vue'
import api from './api'
import moment from 'moment'
import {
  PAGINATION,
  TASK_BELONG_OPTIONS,
  TASK_TYPE_OPTIONS,
  TASK_STATUS_OPTIONS,
  TASK_STATUS_TAG,
  TASK_LEVEL_OPTIONS,
} from './constants'

function createFilters() {
  return {
    taskId: '',
    taskName: '',
    taskBelong: '',
    taskType: '',
    taskStatus: '',
    createdRange: [],
  }
}

export default {
  name: 'WelfareTask',
  components: { Pagination, Tab, TaskFormDialog },
  data() {
    return {
      loading: false,
      filters: createFilters(),
      taskBelongOptions: TASK_BELONG_OPTIONS,
      taskTypeOptions: TASK_TYPE_OPTIONS,
      taskStatusOptions: TASK_STATUS_OPTIONS,
      tableList: [],
      totalCount: 0,
      pagination: { ...PAGINATION },
      formVisible: false,
      formMode: 'add',
      currentId: null,
      currentStatus: '',
    }
  },
  created() {
    this.fetchList()
  },
  methods: {
    statusTag(row) {
      return (
        TASK_STATUS_TAG[row.taskStatus] || {
          text: row.taskStatusDesc || row.taskStatus || '-',
          type: 'info',
        }
      )
    },
    taskLevelText(value) {
      if (!value) return '--'
      const item = TASK_LEVEL_OPTIONS.find((i) => i.value === value)
      return item ? item.label : value
    },
    handleSearch() {
      this.pagination.page = 1
      this.fetchList()
    },
    handleReset() {
      this.filters = createFilters()
      this.pagination = { ...PAGINATION }
      this.fetchList()
    },
    pageChanged({ page, size }) {
      this.pagination = { page, size }
      this.fetchList()
    },
    buildQuery() {
      const query = {
        page: this.pagination.page,
        size: this.pagination.size,
      }
      if (this.filters.taskId) query.taskId = this.filters.taskId
      if (this.filters.taskName) query.taskName = this.filters.taskName
      if (this.filters.taskBelong) query.taskBelong = this.filters.taskBelong
      if (this.filters.taskType) query.taskType = this.filters.taskType
      if (this.filters.taskStatus) query.taskStatus = this.filters.taskStatus
      if (this.filters.createdRange && this.filters.createdRange.length === 2) {
        query.createdStartTime = moment(this.filters.createdRange[0])
          .valueOf()
        query.createdEndTime = moment(this.filters.createdRange[1])
          .valueOf()
      }
      return query
    },
    fetchList() {
      this.loading = true
      api
        .list(this.buildQuery())
        .then((res) => {
          if (res && res.code === 0) {
            const d = res.data || {}
            this.tableList = d.items || d.records || d.list || []
            this.totalCount =
              d.total != null ? d.total : d.totalCount != null ? d.totalCount : 0
          } else {
            this.tableList = []
            this.totalCount = 0
            this.$message.error((res && res.msg) || '查询失败')
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    openAdd() {
      this.formMode = 'add'
      this.currentId = null
      this.currentStatus = ''
      this.formVisible = true
    },
    openView(row) {
      this.formMode = 'view'
      this.currentId = row.taskId || row.id
      this.currentStatus = row.taskStatus
      this.formVisible = true
    },
    openEdit(row) {
      this.formMode = 'edit'
      this.currentId = row.taskId || row.id
      this.currentStatus = row.taskStatus
      this.formVisible = true
    },
    openCopy(row) {
      this.formMode = 'copy'
      this.currentId = row.taskId || row.id
      this.currentStatus = ''
      this.formVisible = true
    },
    handleOnline(row) {
      api
        .updateStatus({ id: row.taskId, taskStatus: 'ONLINE' })
        .then((res) => {
          if (res && res.code === 0) {
            this.$message.success('上线成功')
            this.fetchList()
          } else {
            this.$message.error((res && res.msg) || '上线失败')
          }
        })
    },
    handleOffline(row) {
      this.$confirm(
        '是否确认下线，下线后已领取该用户的任务列表不再展示该任务。',
        '提示',
        { type: 'warning' }
      )
        .then(() => {
          return api.updateStatus({ id: row.taskId, taskStatus: 'OFFLINE' })
        })
        .then((res) => {
          if (res && res.code === 0) {
            this.$message.success('下线成功')
            this.fetchList()
          } else {
            this.$message.error((res && res.msg) || '下线失败')
          }
        })
        .catch(() => { })
    },
  },
}
</script>

<style lang="less" src="../../../styles/button.less" scoped></style>
<style lang="less" scoped>
.pag {
  display: flex;
  justify-content: center;
}
</style>
